export default "__VITE_ASSET__DUA_$8sh__"